import categorias from 'src/assets/data/categories.json'

type Categoria = {
  slug: string
  colors: {
    primary: string
    primary300: string
    primary200: string
    primary100: string
    secondary400?: string
    secondary500?: string
    text?: string
    background?: string
  }
}

export type ColorsType = {
  primary: string
  primary300: string
  primary200: string
  primary100: string
  secondary400?: string
  secondary500?: string
  text?: string
  background?: string
}

export type ThemeType = {
  title: string
  colors: ColorsType
}

const themes = (categorias as Categoria[]).map((categoria) => ({
  title: categoria.slug,
  colors: categoria.colors,
}))

export const getColors = (categorySlug: string): ColorsType => {
  const theme = themes.find((t) => t.title === categorySlug)
  return (
    theme?.colors || {
      primary: '#FF7A00',
      primary300: '#FFDFC2',
      primary200: '#FFE4CC',
      primary100: '#FFF2E5',
    }
  )
}

export default themes
